import React from 'react';
import { IonModal } from '@ionic/react';

// Modals
import { SuccessModal, ErrorModal } from '../../components/modals';

// 3.1 Recibe transactionSummary para pasarlo al SuccessModal
export const MobileDetailMessageComponent = ({ showModal, handleFinish, message, subtitle, transactionSummary }) => {

    return (
        <>
            <IonModal isOpen={showModal.show}>

                {!showModal.error &&
                    // 3.2 Pasa transactionSummary a SuccessModal
                    <SuccessModal
                        message={message}
                        subtitle={<span className="text-success">{ subtitle }</span>}
                        urlImage="assets/images/success.png"
                        title="Estado de Transacción"
                        textButton="NUEVA TRANSACCIÓN"
                        handleFinish={handleFinish}
                        closeModal={() => { handleFinish() }}
                        transactionSummary={transactionSummary} />
                }

                {showModal.error &&
                    <ErrorModal
                        message={showModal.error}
                        urlImage="assets/images/error.png"
                        title="Estado de Transacción"
                        textButton="VOLVER AL INICIO"
                        subtitle={<span className="text-error">Ha ocurrido un error.</span>}
                        handleFinish={handleFinish}
                        closeModal={() => { handleFinish() }} />
                }
            </IonModal>
        </>
    )
}
